export const locale = {
  primary_employer: 'Primary Employer',
  other_employer: 'Other Employer',
  view_as: 'View as: ',
  viewing_as: 'Viewing as: ',
};
